import React, { FC, useContext, useMemo } from 'react';
import classNames from 'classnames';
import {
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  ManageEnterprisePeopleTable,
  SORTING_VALUES,
  TABLE_COLUMNS,
} from './data';
import { EnterpriseMember } from 'models/Enterprises';
import { Checkbox } from 'ncoded-component-library';
import { BODY_CONTENT_GENERATE } from './components/ManagePeopleTableCells';
import ReorderResizeTable from 'components/ReorderResizeTable';
import { RightClickDropdown } from 'components/RightClickDropdown';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';

import './ManagePeopleTable.styles.scss';
import './ManagePeopleTable.styles.responsive.scss';

type ManagePeopleTableProps = {
  className?: string;
};

const ManagePeopleTable: FC<ManagePeopleTableProps> = (props) => {
  const { className } = props;

  const classes = classNames('manage-people-table', className);
  const {
    members,
    isLoading,
    isAllSelected,
    selected,
    totalPages,
    onSelectAll,
    updateSelected,
    getDropdownOptions,
    handleEditMember,
    checkIfMemberIsSelected,
  } = useContext(EnterpriseMembersContext);

  const headerColTransformation = useMemo(
    () => ({
      checkbox: () => (
        <Checkbox checked={isAllSelected} onChange={onSelectAll} />
      ),
    }),
    [isAllSelected, onSelectAll],
  );

  return (
    <ReorderResizeTable
      className={classes}
      headingTranslations={HEADING_TRANSLATIONS}
      columns={TABLE_COLUMNS}
      sortingValues={SORTING_VALUES}
      isDataLoading={isLoading}
      isDragDisabled
      totalPages={totalPages}
      data={members as unknown as ManageEnterprisePeopleTable[]}
      customSizes={CUSTOM_COL_SIZES}
      getIsRowSelected={(member) =>
        checkIfMemberIsSelected(member as unknown as EnterpriseMember)
      }
      onRowClick={(member) =>
        handleEditMember(member as unknown as EnterpriseMember)
      }
      tableHeaderContentTransformations={headerColTransformation}
      tableContentTransformations={TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (member: EnterpriseMember) => (
            <RightClickDropdown
              options={getDropdownOptions(
                selected?.length ? selected : [member],
              )}
            >
              {BODY_CONTENT_GENERATE[col]({
                member,
                isSelectedMember: checkIfMemberIsSelected(member),
                onSelectMember: updateSelected,
              })}
            </RightClickDropdown>
          ),
        }),
        {},
      )}
    />
  );
};

export default ManagePeopleTable;
